import { ConfirmationModal } from 'seagull';
import { RichTextViewer } from 'seagull/components/RichTextViewer';
import { jsx as _jsx } from "react/jsx-runtime";
function toQuillDelta(richTextContent) {
  return {
    type: 'quill-delta',
    value: richTextContent
  };
}
export const QuillViewerModal = props => {
  const {
    title,
    richTextContent,
    onClose,
    testId
  } = props;
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    overflowContent: true,
    contentPadding: "small",
    width: "800px",
    height: "calc(100% - 128px)",
    title: title,
    onCloseButtonClick: onClose,
    "data-testid": testId,
    content: /*#__PURE__*/_jsx(RichTextViewer, {
      value: toQuillDelta(richTextContent)
    })
  });
};